import {
  AlignmentType,
  Document,
  HeadingLevel,
  Paragraph,
  Table,
  TableRow,
  TabStopPosition,
  TabStopType,
  TextRun,
  WidthType,
  PageOrientation,
  Header,
  Footer,
  TableCell,
} from "docx";

export const paragraphArial = (text) => {
  return new Paragraph({
    children: [
      new TextRun({
        text,
        font: "Arial",
      }),
    ],
  });
};
export const paragraphArialBold = (text) => {
  return new Paragraph({
    spacing: {
      before: 200,
    },
    children: [
      new TextRun({
        text,
        font: "Arial",
        bold: true,
      }),
    ],
  });
};
export const paragraphArialBoldPageBreak = (text) => {
  return new Paragraph({
    spacing: {
      before: 200,
    },
    pageBreakBefore:true,
    children: [
      new TextRun({
        text,
        font: "Arial",
        bold: true,
      }),
    ],
  });
};
export const paragraphCentered = (text) => {
  return new Paragraph({
    alignment: AlignmentType.CENTER,

    children: [
      new TextRun({
        text,
        font: "Arial",
      }),
    ],
  });
};
export const paragraphLeft = (text) => {
  return new Paragraph({
    alignment: AlignmentType.LEFT,

    children: [
      new TextRun({
        text,
        font: "Arial",
      }),
    ],
  });
};
